import React from 'react';
import { StepCard } from './StepCard';
import { useStepFlow } from './useStepFlow';
import { StepBudget } from './steps/StepBudget';
import { StepDates } from './steps/StepDates';
import { StepDestination } from './steps/StepDestination';
import { StepRequirements } from './steps/StepRequirements';
import { StepTravelers } from './steps/StepTravelers';
import { StepVibes } from './steps/StepVibes';
import type { FormData } from '../../types';

interface HolidayFormProps {
  form: FormData;
  onFieldChange: (field: keyof FormData, value: unknown) => void;
  onSubmit: () => void;
  onBack?: () => void;
  style?: React.CSSProperties;
}

// Steps: 1=Destination, 2=Dates, 3=Travelers, 4=Vibes, 5=Budget, 6=Requirements
export function HolidayForm({ form, onFieldChange, onSubmit, onBack, style }: HolidayFormProps) {
  const { step, direction, next, back, isBackToWelcome } = useStepFlow();

  // When step becomes 0, trigger onBack to return to welcome page
  React.useEffect(() => {
    if (isBackToWelcome && onBack) {
      onBack();
    }
  }, [isBackToWelcome, onBack]);

  const stepProps = { form, onChange: onFieldChange, onNext: next, onBack: back };

  return (
    <StepCard step={step} direction={direction} style={style}>
      {step === 1 && <StepDestination {...stepProps} />}
      {step === 2 && <StepDates {...stepProps} />}
      {step === 3 && <StepTravelers {...stepProps} />}
      {step === 4 && <StepVibes {...stepProps} />}
      {step === 5 && <StepBudget {...stepProps} />}
      {step === 6 && <StepRequirements {...stepProps} onNext={onSubmit} />}
    </StepCard>
  );
}
